import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrentNavPage } from 'actions';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { STATS_COLORS } from 'SurveyConfig';

export class RatingChart extends Component {
  renderList() {
    return this.props.data && this.props.data.map(elem => ({
      name: elem.value,
      count: elem.count,
    }));
  }

  render() {
    const { color } = this.props;
    return (
      <ResponsiveContainer width="100%" height="auto" aspect={5 / 3}>
        <BarChart
          width={600}
          height={300}
          data={this.renderList()}
          margin={{
            top: 35, right: 30, left: 20, bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" fill={color || STATS_COLORS[0]} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setCurrentNavPage }, dispatch);
}

export default connect(null, mapDispatchToProps)(RatingChart);
